import { Injectable, inject } from '@angular/core';
import { CookieService as CookieToolService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  readonly #cookieService = inject(CookieToolService);
  readonly #tokenCookieName = 'token';
  readonly #sellerCookieName = 'seller';

  recoveryToken() {
    return this.#cookieService.get(this.#tokenCookieName);
  }

  recoverySeller(){
    return this.#cookieService.get(this.#sellerCookieName);
  }

  setCookieSession(value: string) {
    const expires = new Date();
    expires.setHours(expires.getHours() + 12);
    this.#cookieService.set(this.#tokenCookieName, value, expires, '/');
  }

  setCookieSeller(value: string){
    const expires = new Date();
    expires.setHours(expires.getHours() + 12);
    this.#cookieService.set(this.#sellerCookieName, value, expires, '/');
  }

  deleteCookieSession() {
    this.#cookieService.delete(this.#tokenCookieName, '/');
    this.#cookieService.delete(this.#sellerCookieName, '/');
  }

  checkSession() {
    return this.#cookieService.check(this.#tokenCookieName);
  }

  checkSeller() {
    return this.#cookieService.check(this.#sellerCookieName);
  }
}
